import logo from "@/images/logo.png"

export default function Logo({ className }: { className?: string }) {
  return <img src={logo} alt="" className={className} width={64} height={64} />
}
